import { render, staticRenderFns } from "./ContactFormComponent.vue?vue&type=template&id=61bd91ca&scoped=true"
import script from "./ContactFormComponent.vue?vue&type=script&lang=js"
export * from "./ContactFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd91ca",
  null
  
)

export default component.exports